/* eslint-disable no-underscore-dangle */
import { all, call, put, takeEvery } from "redux-saga/effects";
import {
  fetchContactsSuccess,
  showContactMessage,
  setEmployeeWorkingHours,
  workingHoursUpdate,
  setServicesByBusiness,
  submitAllValuesEmployeeResponse,
  submitEditEmployeeDetailsResponse,
  selectedEmployeeDeleteResposne,
  servicesAdminFetchContactsSuccess,
  editWorkingHoursResponse,
  deleteSelectedWorkingHoursResponse,
  employeeFailResponse,
  employeeAddWorkingHoursForcefullyResponse,
  employeeDeleteWorkingHoursForcefullyResponse,
  employeeOutOfBusinessHoursAdd,
  employeeDontDeleteWorkingHours,
  employeeEditWorkingHoursForcefullyResponse,
  bulkEmployeeCloseWorkingHours,
  bulkEmployeeAddWorkingHoursForcefullyResponse,
  employeeBusinessClosureSubmitResponse,
  employeeBusinessWorkingHoursAddForcefullyResponse,
  employeeBusinessWorkingHoursEditForcefullyResponse,
  employeeBusinessWorkingHoursDeleteForcefullyResponse,
  employeeBusinessWorkingHoursDeleteSubmitResponse,
  employeeBusinessWorkingHoursEditSubmitResponse,
  employeeBusinessWorkingHoursHaveAppointment,
  employeeBusinessWorkingHoursDeleteAppointment,
  employeeBusinessWorkingHoursSubmitResponse,
  bulkEmployeeCalenderResponse,
} from "actions";
import axios from "../services/admin";

import admin from "../services/admin";
import {
  FETCH_ALL_CONTACT,
  GET_EMPLOYEE_WORKING_HOURS,
  SUBMIT_WORKING_HOURS_FORM,
  GET_ALL_SERVICES_BY_BUSINESS,
  GET_ALL_SERVICES_BY_BUSINESS_SUPER_ADMIN,
  SUBMIT_ALL_VALUES_EMPLOYEE,
  SELECTED_EMPLOYEE_DELETE,
  DELETE_SELECTED_WORKING_HOURS,
  EMPLOYEE_ADD_WORKING_HOURS_FORCEFULLY,
  EMPLOYEE_DELETE_WORKING_HOURS_FORCEFULLY,
  BULK_EMPLOYEE_ADD_WORKING_HOURS_FORCEFULLY,
  EMPLOYEE_BUSINESS_CLOSURE_SUBMIT,
  EMPLOYEE_BUSINESS_WORKING_HOURS_EDIT_FORCEFULLY,
  EMPLOYEE_BUSINESS_WORKING_HOURS_SUBMIT,
  EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_SUBMIT,
  EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_FORCEFULLY,
  GET_EMPLOYEE_PLAN,
} from "../constants/ActionTypes";
import {formatPhone} from '../util/normalizePhone';
import { getEmployeePlanSuccess, changeAdminEmployeeDisplay, changeAddEmployeeState } from "../actions";

function* fetchContactRequest({ payload }) {
  try {
    const response = yield axios.get(`/employees?business_name=${payload}`);
    let Data = response.data;
    Data.forEach(element => {
      element.primarydetails.phonenumber = formatPhone(element.primarydetails.phonenumber);
    })
    yield put(fetchContactsSuccess(Data));
  } catch (error) {
    yield put(employeeFailResponse(error));
  }
}

function* fetchWorkingHours({ payload }) {
  try {
    const response = yield axios.get(`/employees/${payload.employeeWorkingHoursId}`);
    const { data } = response;
    const { schedule } = data;

    yield put(setEmployeeWorkingHours(schedule));
  } catch (error) {
    yield put(employeeFailResponse(error.response.data.message));
  }
}

function* fetchSubmitWorkingHours({ payload }) {
  try {
    const {
      employee: employeeId,
      from: fromId,
      to: toId,
      entryType: entryTypeId,
      editWorkingHoursState,
      addWorkingHoursState,
      editId,
      editEmployees,
      addEmployees,
    } = payload;
    if (typeof employeeId === "string") {
      if (addWorkingHoursState) {
        const response = yield axios.post("/employeeschedules", payload);
        if (response.data.message) {
          yield put(employeeOutOfBusinessHoursAdd(payload));
        } else {
          const { from, to, employee, entryType, _id } = response.data;
          const { _id: employeeId } = employee;
          const isNew = true;
          yield put(workingHoursUpdate({ from, to, _id, entryType, isNew, employeeId }));
        }
      } else if (editWorkingHoursState) {
        const response = yield axios.put(`/employeeschedules/${editId}`, {
          employee: employeeId,
          from: fromId,
          to: toId,
          entryType: entryTypeId,
        });

        if (response.data.message) {
          yield put(employeeOutOfBusinessHoursAdd(payload));
        } else {
          const { from, to, entryType, _id, employee } = response.data;
          const { _id: employeeId } = employee;
          const isNew = true;
          yield put(editWorkingHoursResponse({ from, to, _id, entryType, employeeId, isNew }));
        }
      }
    } else {
      const addEmployeesPromise = addEmployees.map(item => axios.post("/employeeschedules", item));
      const editEmployeesPromise = editEmployees.map(item =>
        axios.put(`/employeeschedules/${item._id}`, item)
      );

      const response = yield Promise.all(addEmployeesPromise);
      const finalAddEmployeesData = [];
      const finalEditEmployeesData = [];
      const haveMessageAddEmployees = [];
      const haveMessageEditEmployees = [];
      response.forEach((item, index) => {
        if (item.data.message) {
          haveMessageAddEmployees.push(addEmployees[index]);
        } else {
          finalAddEmployeesData.push(item.data);
        }
      });

      if (editEmployees.length !== 0) {
        const response1 = yield Promise.all(editEmployeesPromise);

        response1.forEach((item, index) => {
          if (item.data.message) {
            haveMessageEditEmployees.push(editEmployees[index]);
          } else {
            finalEditEmployeesData.push(item.data);
          }
        });
      }

      const condition = haveMessageAddEmployees.length !== 0;
      const condition1 = haveMessageEditEmployees.length !== 0;

      if (condition || condition1) {
        yield put(
          bulkEmployeeCloseWorkingHours({
            employee: employeeId,
            from: fromId,
            to: toId,
            entryType: entryTypeId,
            haveMessageAddEmployees,
            haveMessageEditEmployees,
            finalAddEmployeesData,
            finalEditEmployeesData,
          })
        );
      } else {
        const isNew = true;
        yield put(
          workingHoursUpdate({
            from: fromId,
            to: toId,
            employeeId,
            entryType: entryTypeId,
            isNew,
          })
        );
        yield put(bulkEmployeeCalenderResponse({ finalAddEmployeesData, finalEditEmployeesData }));
      }
    }
  } catch (error) {
    if (error.response) {
      yield put(employeeFailResponse(error.response.data.message));
    }
  }
}

function* fetchBusinessServices({ payload }) {
  try {
    const response = yield axios.get(`/servicesbybusinesses`, {
      params: {
        location: payload,
      },
    });
    yield put(servicesAdminFetchContactsSuccess(response.data));
    yield put(setServicesByBusiness(response.data));
  } catch (error) {
    yield put(employeeFailResponse(error.response.data.message));
  }
}

function* fetchBusinessServicesSuperAdmin({ payload }) {
  try {
    console.log('hey')
    const response = yield axios.get(`/services`);
    yield put(servicesAdminFetchContactsSuccess(response.data));
    yield put(setServicesByBusiness(response.data));
  } catch (error) {
    yield put(employeeFailResponse(error.response.data.message));
  }
}

function* fetchEmployeeAddData({ payload }) {
  const user = JSON.parse(localStorage.getItem("user-data"));
  const location = localStorage.getItem("business_location");
  const { business } = user;
  const { business_locations } = business;
  const business_operations = business_locations[0].operations;

  try {
    const { addEmployeeState, editEmployeeState } = payload;
    if (addEmployeeState) {
      const {
        formValues,
        imageFile,
        serviceTableServices: services_offered,
        business: business_name,
        fetchBusinessId,
      } = payload;
      formValues.phonenumber ='+'+formValues.phonenumber.replace(/[^\d]/g, '');
      const formValuesResponse = yield axios.post("/users", formValues);

      const { title, firstname, lastname, enabled } = formValues;
      const serviceRequestData = {
        title,
        firstname,
        lastname,
        enabled,
        business_name,
        location,
        services_offered,
        operations: business_operations,
        schedule: [],
        primarydetails: formValuesResponse.data._id,
      };
      const servicesResponse = yield axios.post("/employees", serviceRequestData);

      const myEmployee = { ...servicesResponse.data };
      if (imageFile) {
        const file = new FormData();
        file.append("files", imageFile);
        file.append("refId", servicesResponse.data._id);
        file.append("ref", "employees");
        file.append("field", "photo");

        const imageResponse = yield axios.post("/upload?files", file, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        myEmployee.photo = imageFile ? { ...imageResponse.data[0] } : null;
      }
      yield put(submitAllValuesEmployeeResponse(myEmployee));
    } else if (editEmployeeState) {
      const {
        formValues,
        imageFile,
        serviceTableServices: services_offered,
        business: business_name,
        fetchBusinessId,
        operations: EmployeeOperations,
      } = payload;

      const { _id } = formValues;

      if (formValues.email === formValues.checkEmail) {
        delete formValues.email;
        delete formValues.username;
      }
      delete formValues._id;
      let {_id: primaryId} = formValues.primarydetails;
      delete formValues.primarydetails;
      formValues.phonenumber ='+'+formValues.phonenumber.replace(/[^\d]/g, '');
      const formValuesResponse = yield axios.put(
        `/users/${primaryId}`,
        formValues
      );

      const { title, firstname, lastname, enabled } = formValues;
      const serviceRequestData = {
        title,
        firstname,
        lastname,
        enabled,
        // business_name,
        // location,
        services_offered,
        primarydetails: formValuesResponse.data._id,
      };

      if (!EmployeeOperations) {
        serviceRequestData.operations = business_operations;
      }

      const servicesResponse = yield axios.put(`/employees/${_id}`, serviceRequestData);
      let imageResponse = null;
      let imageData = null;
      const myEmployee = { ...servicesResponse.data };
      console.log("TCL: function*fetchEmployeeAddData -> servicesResponse.data", servicesResponse.data)
      if (imageFile) {
        console.log('payload.imageid', payload.imageid)
        if(payload.imageid != "") {
        console.log('payload.imageid 1', payload.imageid)
        yield admin.delete(`/upload/files/${payload.imageid}`);
        }
        const file = new FormData();
        file.append("files", imageFile);
        file.append("refId", servicesResponse.data._id);
        file.append("ref", "employees");
        file.append("field", "photo");

        imageResponse = yield axios.post("/upload?files", file, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        imageData = imageResponse.data === true ? imageFile : imageResponse.data[0];
      }

      myEmployee.photo = imageData ? { ...imageData } : null;
      yield put(submitEditEmployeeDetailsResponse(myEmployee));
    }
  } catch (error) {
    yield put(employeeFailResponse(error.response.data.message));
  }
}

function* fetchEmployeeDelete({ payload }) {
  try {
    const { allContact } = payload;
    let deleteEmployeeIds = allContact.filter(employee => employee.selected);
    const deletedEmployeePrimaryIds = deleteEmployeeIds.map(
      employee => employee.primarydetails._id
    );

    deleteEmployeeIds = deleteEmployeeIds.map(employee => employee.id);

    const myUsersRequestData = deletedEmployeePrimaryIds.map(id => axios.delete(`/users/${id}`));

    const myEmployeesRequestData = deleteEmployeeIds.map(id => axios.delete(`/employees/${id}`));
    const usersResponse = yield Promise.all(myUsersRequestData);
    const employeeResposne = yield Promise.all(myEmployeesRequestData);
    yield put(selectedEmployeeDeleteResposne(deletedEmployeePrimaryIds));
  } catch (error) {
    // yield put(showContactMessage(error.response.data.message));

    yield put(selectedEmployeeDeleteResposne());
  }
}

function* fetchWorkingHoursDelete({ payload }) {
  try {
    const { selection, employeeWorkingHours } = payload;
    const deletePromises = selection.map(id => axios.delete(`/employeeschedules/${id}`));

    const response = yield Promise.all(deletePromises);

    const dontDelete = [];
    const deleteSelection = [];

    response.forEach(item => {
      if (item.data.message === "active_appointment_found_for_deleted_working_hour") {
        dontDelete.push(item.data._id);
      } else {
        deleteSelection.push(item.data._id);
      }
    });

    if (dontDelete.length === 0) {
      yield put(deleteSelectedWorkingHoursResponse(deleteSelection));
    } else {
      yield put(employeeDontDeleteWorkingHours(dontDelete));
    }
  } catch (error) {
    yield put(employeeFailResponse(error.response.data.message));
  }
}

function* addWorkingHoursForcefully({ payload }) {
  try {
    const {
      employee: employeeToId,
      from: fromId,
      to: toId,
      entryType: entryTypeId,
      editWorkingHoursState,
      addWorkingHoursState,
      full_day_closed,
      reason_for_closure: reason_for_closure_submit,
      comment,
      editId,
    } = payload;
    if (addWorkingHoursState) {
      const response = yield axios.post("/employeeschedules?forcefully=true", payload);
      const {
        from,
        to,
        employee,
        entryType,
        _id,
        full_day_closed,
        comment,
        reason_for_closure,
      } = response.data;
      const { _id: employeeId } = employee;
      const isNew = true;

      if (entryType === "available") {
        yield put(
          employeeAddWorkingHoursForcefullyResponse({ from, to, _id, entryType, isNew, employeeId })
        );
      } else {
        yield put(
          employeeBusinessWorkingHoursAddForcefullyResponse({
            from,
            to,
            _id,
            entryType,
            isNew,
            employeeId,
            full_day_closed,
            comment,
            reason_for_closure,
          })
        );
      }
    } else if (editWorkingHoursState) {
      const response = yield axios.put(`/employeeschedules/${editId}?forcefully=true`, {
        employee: employeeToId,
        from: fromId,
        to: toId,
        entryType: entryTypeId,
        full_day_closed,
        comment,
        reason_for_closure_submit,
      });
      const {
        from,
        to,
        employee,
        entryType,
        _id,
        full_day_closed,
        comment,
        reason_for_closure,
      } = response.data;
      const { _id: employeeId } = employee;
      const isNew = true;

      if (entryType === "available") {
        yield put(
          employeeEditWorkingHoursForcefullyResponse({
            from,
            to,
            _id,
            entryType,
            isNew,
            employeeId,
          })
        );
      } else {
        yield put(
          employeeBusinessWorkingHoursEditForcefullyResponse({
            from,
            to,
            _id,
            entryType,
            employeeId,
            isNew,
            full_day_closed,
            comment,
            reason_for_closure,
          })
        );
      }
    }
  } catch (error) {
    yield put(employeeFailResponse(error.response.data.message));
  }
}

function* deleteWorkingHoursForcefully({ payload }) {
  try {
    const deletePromises = payload.map(id =>
      axios.delete(`/employeeschedules/${id}?forcefully=true`)
    );
    const response = Promise.all(deletePromises);
    yield put(employeeDeleteWorkingHoursForcefullyResponse(payload));
  } catch (error) {
    yield put(employeeFailResponse(error.response.data.message));
  }
}

function* bulkAddWorkingHoursForcefully({ payload }) {
  try {
    const {
      employee,
      from,
      to,
      entryType,
      haveMessageAddEmployees,
      haveMessageEditEmployees,
      finalAddEmployeesData,
      finalEditEmployeesData,
    } = payload;
    const addEmployeesPromise = haveMessageAddEmployees.map(item =>
      axios.post("/employeeschedules?forcefully=true", item)
    );
    const editEmployeesPromise = haveMessageEditEmployees.map(item =>
      axios.put(`/employeeschedules/${item._id}?forcefully=true`, item)
    );

    const response = yield Promise.all(addEmployeesPromise);

    response.forEach(item => finalAddEmployeesData.push(item.data));

    const isNew = true;
    if (haveMessageEditEmployees.length !== 0) {
      const response1 = yield Promise.all(editEmployeesPromise);
      response1.forEach(item => finalEditEmployeesData.push(item.data));
    }
    yield put(
      bulkEmployeeAddWorkingHoursForcefullyResponse({
        from,
        to,
        employee,
        entryType,
        isNew,
      })
    );
    yield put(bulkEmployeeCalenderResponse({ finalAddEmployeesData, finalEditEmployeesData }));
  } catch (error) {
    yield put(employeeFailResponse(error.response.data.message));
  }
}

function* employeeBusinessClosureSubmit({ payload }) {
  try {
   
    const { id, operations } = payload;
    const employeeOperationsResponse = yield axios.put(`/employees/${id}`, {
      operations,
    });
    yield put(employeeBusinessClosureSubmitResponse(employeeOperationsResponse.data));
  } catch (error) {
    yield put(employeeFailResponse(error.response.data.message));
  }
}

function* employeeBusinessWorkingHoursSubmit({ payload }) {
  try {
    const {
      employee: employeeId,
      from: fromId,
      to: toId,
      entryType: entryTypeId,
      editWorkingHoursState,
      addWorkingHoursState,
      full_day_closed,
      reason_for_closure: reason_for_closure_submit,
      comment,
      editId,
    } = payload;
    if (addWorkingHoursState) {
      const response = yield axios.post("/employeeschedules", payload);
      if (response.data.message) {
        yield put(employeeBusinessWorkingHoursHaveAppointment(payload));
      } else {
        const {
          from,
          to,
          employee,
          entryType,
          _id,
          full_day_closed,
          comment,
          reason_for_closure,
        } = response.data;
        const { _id: employeeId } = employee;
        const isNew = true;

        yield put(
          employeeBusinessWorkingHoursSubmitResponse({
            from,
            to,
            _id,
            entryType,
            isNew,
            employeeId,
            full_day_closed,
            comment,
            reason_for_closure,
          })
        );
      }
    } else if (editWorkingHoursState) {
      const response = yield axios.put(`/employeeschedules/${editId}`, {
        employee: employeeId,
        from: fromId,
        to: toId,
        entryType: entryTypeId,
        full_day_closed,
        comment,
        reason_for_closure_submit,
      });

      if (response.data.message) {
        yield put(employeeBusinessWorkingHoursHaveAppointment(payload));
      } else {
        const {
          from,
          to,
          employee,
          entryType,
          _id,
          full_day_closed,
          comment,
          reason_for_closure,
        } = response.data;
        const { _id: employeeId } = employee;
        const isNew = true;
        yield put(
          employeeBusinessWorkingHoursEditSubmitResponse({
            from,
            to,
            _id,
            entryType,
            employeeId,
            isNew,
            full_day_closed,
            comment,
            reason_for_closure,
          })
        );
      }
    }
  } catch (error) {
    yield put(employeeFailResponse(error.response.data.message));
  }
}

function* employeeBusinessWorkingHoursDeleteSubmit({ payload }) {
  try {
    const deletePromises = payload.map(id =>
      axios.delete(`/employeeschedules/${id}?exceptionbased=true`)
    );

    const response = yield Promise.all(deletePromises);

    const dontDelete = [];
    const deleteSelection = [];

    response.forEach(item => {
      if (item.data.message === "active_appointment_found_for_deleted_working_hour") {
        dontDelete.push(item.data._id);
      } else {
        deleteSelection.push(item.data._id);
      }
    });

    if (dontDelete.length === 0) {
      yield put(employeeBusinessWorkingHoursDeleteSubmitResponse(deleteSelection));
    } else {
      yield put(employeeBusinessWorkingHoursDeleteAppointment(dontDelete));
    }
  } catch (error) {
    yield put(employeeFailResponse(error.response.data.message));
  }
}

function* fetchEmployeeBusinessWorkingHourAddForcefully({ payload }) {
  try {
    const {
      employee: employeeToId,
      from: fromId,
      to: toId,
      entryType: entryTypeId,
      editWorkingHoursState,
      addWorkingHoursState,
      full_day_closed,
      comment,
      editId,
    } = payload;

    if (addWorkingHoursState) {
      const response = yield axios.post("/employeeschedules?forcefully=true", payload);
      const { from, to, employee, entryType, _id, full_day_closed, comment } = response.data;
      const { _id: employeeId } = employee;
      const isNew = true;

      yield put(
        employeeBusinessWorkingHoursAddForcefullyResponse({
          from,
          to,
          _id,
          entryType,
          isNew,
          employeeId,
          full_day_closed,
          comment,
        })
      );
    } else if (editWorkingHoursState) {
      const response = yield axios.put(`/employeeschedules/${editId}?forcefully=true`, {
        employee: employeeToId,
        from: fromId,
        to: toId,
        entryType: entryTypeId,
        full_day_closed,
        comment,
      });
      const { from, to, employee, entryType, _id, full_day_closed, comment } = response.data;
      const { _id: employeeId } = employee;
      const isNew = true;
      yield put(
        employeeBusinessWorkingHoursEditForcefullyResponse({
          from,
          to,
          _id,
          entryType,
          employeeId,
          isNew,
          full_day_closed,
          comment,
        })
      );
    }
  } catch (error) {
    yield put(employeeFailResponse(error.response.data.message));
  }
}

function* employeeBusinessWorkingHoursDeleteForcefully({ payload }) {
  try {
    const deletePromises = payload.map(id =>
      axios.delete(`/employeeschedules/${id}?forcefully=true&exceptionbased=true`)
    );
    const response = Promise.all(deletePromises);
    yield put(employeeBusinessWorkingHoursDeleteForcefullyResponse(payload));
  } catch (error) {
    yield put(employeeFailResponse(error.response.data.message));
  }
}

function* getEmployeePlan({payload}) {
  try {
    const businesslocations = localStorage.getItem("business_location");
    const response = yield axios.get(`/businesslocations/${businesslocations}`);
    console.log("RESPONSERONAK",response);
    const noOfEmployee = response.data.no_of_employee;
    if(noOfEmployee != 10 && payload == noOfEmployee) {
      yield put(getEmployeePlanSuccess(noOfEmployee))
    } else {
      yield put(changeAddEmployeeState(true));
      yield put(changeAdminEmployeeDisplay(2));
    }
  } catch (error) {
    yield put(employeeFailResponse(error));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(FETCH_ALL_CONTACT, fetchContactRequest),
    takeEvery(GET_EMPLOYEE_WORKING_HOURS, fetchWorkingHours),
    takeEvery(SUBMIT_WORKING_HOURS_FORM, fetchSubmitWorkingHours),
    takeEvery(GET_ALL_SERVICES_BY_BUSINESS, fetchBusinessServices),
    takeEvery(GET_ALL_SERVICES_BY_BUSINESS_SUPER_ADMIN, fetchBusinessServicesSuperAdmin),
    takeEvery(SUBMIT_ALL_VALUES_EMPLOYEE, fetchEmployeeAddData),
    takeEvery(SELECTED_EMPLOYEE_DELETE, fetchEmployeeDelete),
    takeEvery(DELETE_SELECTED_WORKING_HOURS, fetchWorkingHoursDelete),
    takeEvery(EMPLOYEE_ADD_WORKING_HOURS_FORCEFULLY, addWorkingHoursForcefully),
    takeEvery(EMPLOYEE_DELETE_WORKING_HOURS_FORCEFULLY, deleteWorkingHoursForcefully),
    takeEvery(BULK_EMPLOYEE_ADD_WORKING_HOURS_FORCEFULLY, bulkAddWorkingHoursForcefully),
    takeEvery(EMPLOYEE_BUSINESS_CLOSURE_SUBMIT, employeeBusinessClosureSubmit),
    takeEvery(EMPLOYEE_BUSINESS_WORKING_HOURS_SUBMIT, employeeBusinessWorkingHoursSubmit),
    takeEvery(GET_EMPLOYEE_PLAN, getEmployeePlan),
    takeEvery(
      EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_SUBMIT,
      employeeBusinessWorkingHoursDeleteSubmit
    ),
    takeEvery(
      EMPLOYEE_BUSINESS_WORKING_HOURS_EDIT_FORCEFULLY,
      fetchEmployeeBusinessWorkingHourAddForcefully
    ),
    takeEvery(
      EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_FORCEFULLY,
      employeeBusinessWorkingHoursDeleteForcefully
    ),
  ]);
}



// WEBPACK FOOTER //
// ./sagas/EmployeeSaga.js